import React from 'react';
import {
  FormattedMessage,
} from 'react-intl';

import {
  Col,
  Row,
} from '@folio/stripes/components';

import css from './record-linkage-title.css';

const RecordLinkageTitle = () => (
  <Row className={css.recordLinkageHeaderRow}>
    <Col
      data-test-record-linkage-edit-title-name
      className={css.recordLinkageHeaderCell}
      sm={2}
    >
      <FormattedMessage id="ui-task-list.recordLinkage.field.name" />
      <span className={css.asterisk}>*</span>
    </Col>
    <Col
      data-test-record-linkage-edit-title-url
      className={css.recordLinkageHeaderCell}
      sm={9}
    >
      <FormattedMessage id="ui-task-list.recordLinkage.field.url" />
      <span className={css.asterisk}>*</span>
    </Col>
    <Col
      data-test-record-linkage-edit-title-action
      className={css.recordLinkageHeaderCell}
      sm={1}
    >
      <FormattedMessage id="ui-task-list.recordLinkage.field.action" />
    </Col>
  </Row>
);

export default RecordLinkageTitle;
